import './styles/warning-alert-bar.scss';
import React, {PropTypes} from 'react';
import AlertBarBase from './alert-bar-base';

export const WarningAlertBar = props =>
    <div className='warning-alert-bar'>
        <AlertBarBase
            alertTitle={props.alertTitle}
            dismissHandler={props.dismissHandler}
            iconClass='icon-alertWarning'
            isDismissable={props.isDismissable}
            timeoutLength={props.timeoutLength}
            willAutoDismiss={props.willAutoDismiss}
        >
            {props.children}
        </AlertBarBase>
    </div>;

WarningAlertBar.displayName = 'WarningAlertBar';

WarningAlertBar.propTypes = {
    alertTitle: PropTypes.any.isRequired,
    children: PropTypes.any.isRequired,
    dismissHandler: PropTypes.func.isRequired,
    isDismissable: PropTypes.bool,
    timeoutLength: PropTypes.number,
    willAutoDismiss: PropTypes.bool
};

WarningAlertBar.defaultProps = {
    isDismissable: true,
    willAutoDismiss: true
};

export default WarningAlertBar;



// WEBPACK FOOTER //
// ./src/shared/components/alert-bar/warning-alert-bar.js